<div class="review-dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0 mb-24">
        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{title}}</span>
            <button mat-icon-button class="mat-icon-button white-fg"
                    (click)="dialogRef.close()"
                    aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0 pt-0" fusePerfectScrollbar>
        <form [formGroup]="form" #formControl="ngForm" fxLayout="column" fxFlex>
            
            <mat-form-field color="accent" class="review-label w-100-p p-8 m-0 form-control">
                <mat-label>Label</mat-label>
                <input id="label" matInput #input class="form-control" formControlName="label" name="label" [setFocus]="true" max-length="50" [readonly]="readOnly" required>
            </mat-form-field>
            <validation-errors [control]="form.get('label')" style="padding-left: 8px;"></validation-errors>

            <mat-form-field *ngIf="override" class="w-100-p p-8 m-0 form-control">
                <mat-label>Override Reason</mat-label>
                <textarea matInput
                    name="overrideReason"
                    formControlName="overrideReason"
                    rows="2" maxlength="200" required [readonly]="readOnly">
                </textarea>
            </mat-form-field>
            <validation-errors [control]="form.get('overrideReason')" style="padding-left: 8px;"></validation-errors>

            <mat-form-field class="w-100-p p-8 m-0 form-control">
              <mat-label>Internal Comments</mat-label>
                <textarea matInput
                    name="comments"
                    formControlName="comments"
                    rows="10" maxlength="2000" [readonly]="readOnly">
                </textarea>
            </mat-form-field>
        </form>
    </div>
    <div *ngIf="!readOnly" mat-dialog-actions class="m-0 p-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div>
        <button *ngIf="action === enumReviewStatus.Accepted" id="btnAccept" mat-raised-button
                type="submit"
                [disabled]="((!form.valid) || form.pristine || saving)" 
                (click)="accept()"
                [ngClass]="{'bg-green':!(((!form.valid) || form.pristine || saving))}"
                aria-label="ACCEPT">
            ACCEPT
        </button>
        <button *ngIf="action === enumReviewStatus.Rejected" id="btnReject" mat-raised-button
                type="submit"
                [disabled]="((!form.valid) || form.pristine || saving)" 
                (click)="reject()"
                class="mat-warn"
                aria-label="REJECT">
            REJECT
        </button>
        <button *ngIf="action === enumReviewStatus.Reviewed" id="btnReview" mat-raised-button
                type="submit"
                [disabled]="((!form.valid) || form.pristine || saving)" 
                (click)="review()"
                class="mat-accent"
                aria-label="REVIEW">
            REVIEW
        </button>
        </div>
    </div>
</div>
